import React from 'react'
import PropTypes from 'prop-types'

export const FormField = props => {
  return (
    <div className="form-group">
      <label>{props.label}</label>
      <input
        name={props.name}
        className="form-control"
        value={props.value}
        onChange={props.handler}
        type={props.type}
      />
      {props.helpText && (
        <small className="text-muted mt-1 d-block">{props.helpText}</small>
      )}
    </div>
  )
}

FormField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handler: PropTypes.func,
  type: PropTypes.string,
  helpText: PropTypes.string,
}
